import {GetCustomerV2ApiResponse} from '@dms/api/customer';

import {Nullish} from 'shared/web';

/**
 * Returns the contact person only when it is one of the customer's contacts. The API refuses
 * a consent given by a contact person of another customer.
 */
export const getCustomerContactPersonId = (
  customer: Pick<GetCustomerV2ApiResponse, 'contacts'> | Nullish,
  contactPersonId: string | Nullish
) => customer?.contacts?.find((contact) => contact.id === contactPersonId)?.id ?? null;
